module.exports = __webpack_public_path__ + "static/media/amazon-music-color.48062d62.png";